import React from 'react';
import { Box } from '@mui/material';
import ProjectTimeline from './ProjectTimeline';
import ProjectWorkflow from './ProjectWorkflow';

const ProjectMain = () => {
  return (
    <Box sx={{ width: '100%', marginX: 'auto', px: 2 }}> 
      <ProjectTimeline />
      <ProjectWorkflow />
    </Box>
  );
};

export default ProjectMain;
